module.exports = __webpack_public_path__ + "img/heroImg.2c749dec.svg";